import Vue from 'vue'
import Vuex from 'vuex'
import VueCookie from 'vue-cookie'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'staging'

export default new Vuex.Store({
  modules: {
    // 共通モーダルの表示
    modal: {
      namespaced: true,
      state: {
        isShow: false
      }
    },
    scope: {
      namespaced: true,
      state: {
        isManager: false,
        isBusiness: false,
        isDownload: false
      }
    },
    tags: []
  },
  strict: debug,
  mutations: {
    updateScope (state, val) {
      // 状態を変更する
      var scope = VueCookie.get('scope') || ''
      var scopes = scope.split(' ')
      state.scope.isManager = scopes.indexOf('admin-manager') > 0
      state.scope.isBusiness = scopes.indexOf('admin-business') > 0
      state.scope.isDownload = scopes.indexOf('admin-download') > 0
    },
    modalShow (state, val) {
      // 状態を変更する
      state.modal.isShow = val
    },
    tagRefresh (state, val) {
      state.tags = val
    }
  }
})



// WEBPACK FOOTER //
// ./src/service/BaseVuex.js